import { LinkMarkSpec, LINK_KEY } from '@techchange/pm-specs';

import LinkButton from './components/LinkButton';
import LinkTooltip from './components/LinkTooltip';
import linkKeymap from './plugins/keymap';
import linkSelectionPlugin, { linkSelectionPluginKey } from './plugins/linkSelection';
import linkViewPlugin from './plugins/linkView';


const link = {

	marks() {

		return {
			[LINK_KEY]: LinkMarkSpec,
		};

	},

	plugins(options) {

		return [
			linkSelectionPlugin(),
			linkKeymap,
			linkViewPlugin(options.scope, options.scopeId),
		];

	},

	toolbarButtons() {

		return [{ Button: LinkButton, key: 'linkButton' }];

	},

	tooltips() {

		return [
			{
				Tooltip: LinkTooltip,
				key: (state) => {

					const { selectedLink } = linkSelectionPluginKey.getState(state);

					return selectedLink ? selectedLink.attrs.href : 'LinkTooltip';

				},
			}
		];

	},

};

export default link;
